import styled from 'styled-components';
import { Button } from '@material-ui/core';

const ButtonStyles = styled(Button)`
	.MuiButton-label {
		font-size: 16px;
		font-weight: 300;
		text-transform: capitalize;
		color: #ffffff;
	}

	&.MuiButton-root {
		height: 39px;
		margin: 0px 3px;
	}
	&.MuiButton-root:hover {
		background-color: rgba(255, 255, 255, 0.15);
	}
`;

export default ButtonStyles;
